module.exports = __webpack_public_path__ + "static/media/ship-small@3x.4cece490.png";